$(function() {
  var ZIndex = 0;
  var isDraggable = false;
  var WindowWidth = $(window).width();
  var WindowHeight = $(window).height();

    $(".title_item").each(function () {
    var CSSItem = { 'left' : 0.1*WindowWidth, 'top' : 0.05*WindowHeight};
    $(this).css(CSSItem);
  });
  
  $(window).on('orientationchange', function() {
  location.reload(); // simplest fix — or recompute positions proportionally
});
  
  $(".item").each(function () {
    var RotateDeg = RandomNumber(300, 420);
    var ScaleDeg = 1.0;
    var CSSItem = { 'left' : RandomNumber(0.1*WindowWidth, 0.9*WindowWidth), 'top' : RandomNumber(0.1*WindowHeight, 0.7*WindowHeight), 'transform' : 'scale('+ ScaleDeg +')', 'transform' : 'rotate('+ RotateDeg +'deg)'};
    $(this).css(CSSItem);
  });
  
  $(".item").on("mouseup touchend", function(e){
    $(".item").find('p').remove();
    if(!isDraggable) {
      ZIndex++;
      var CSSItem = { 'z-index' : ZIndex, 'transform' : 'rotate(0deg)'};
      $(this).css(CSSItem);
    }
  });
  
    $(".title_item").draggable({
    cursor: 'move',
    start: function() {
      isDraggable = true;
      ZIndex++;
      var CSSItem = { 'z-index' : ZIndex };
      $(this).css(CSSItem);
    },
    stop: function() {
      var RotateDeg = RandomNumber(300, 420);
      var CSSItem = { 'transform' : 'rotate('+ RotateDeg +'deg)' };
      $(this).css(CSSItem);
      isDraggable = false;
    }
  });
  
  $(".item").draggable({
    cursor: 'move',
    containment: 'window',
    start: function() {
      isDraggable = true;
      ZIndex++;
      var CSSItem = { 'z-index' : ZIndex, 'transform' : 'scale(1.1)'};
      $(this).css(CSSItem);
    },
    stop: function() {
      var RotateDeg = RandomNumber(300, 420);
      var CSSItem = { 'transform' : 'rotate('+ RotateDeg +'deg)', 'transform' : 'scale(1.0)'};
      $(this).css(CSSItem);
      isDraggable = false;
    }
  });
  
  function RandomNumber(MaxValue, MinValue) {
    return Math.round(Math.random() * (MaxValue - MinValue) + MinValue);
  }
});